const getRandomPercentage = () => Math.round(Math.random() * 100);
const normalizedCanaryPercentage = (canaryPercentage) => {
    if (canaryPercentage > 100) {
        return 100;
    }
    if (canaryPercentage < 0) {
        return 0;
    }
    return canaryPercentage;
};

export { getRandomPercentage, normalizedCanaryPercentage };
